import { BaseReportingModel } from "./BaseReportingModel";

export type ReportingResult = BaseReportingModel & {
    reportDate: Date;
    data?: { [key: string]: ReportingResultItem[] };
}

export type ReportingResultItem = {
    date: Date;
    value: number;
}

export enum DatasetTotalResultEnum {
    DataLength = "DataLength",
    DataSize = "DataSize",
    DataLengthTest = "DataLengthTest",
    DataSizeTest = "DataSizeTest",
    AddedDataLength = "AddedDataLength",
    AddedDataSize = "AddedDataSize",
    AddedDataLengthTest = "AddedDataLengthTest",
    AddedDataSizeTest = "AddedDataSizeTest",
}